<template>
    <project-step-container
            prev-to="deep_customer_empathy_3"
            :on-discard-project="redirection"
            :on-keep-version-project="redirection"
            @next-click="updateProject">
        <b-row>
            <b-col cols="12" class="main-text" tabindex="0">
                {{getMessage(4, 'empathy-map-sub')}}
            </b-col>
        </b-row>
        <b-row class="mt-3">
            <b-col cols="12" class="mt-3">
                <label for="first-thing"> {{getMessage(4, 'firstThing')}} </label>
                <input id="first-thing" type="text" v-model="form.firstThing"/>
            </b-col>
            <b-col cols="12" class="mt-3">
                <label for="second-thing"> {{getMessage(4, 'secondThing')}} </label>
                <input id="second-thing" type="text" v-model="form.secondThing"/>
            </b-col>
            <b-col cols="12" class="mt-3">
                <label for="third-thing">{{getMessage(4, 'thirdThing')}} </label>
                <input id="third-thing" type="text" v-model="form.thirdThing"/>
            </b-col>
        </b-row>
    </project-step-container>
</template>

<script>
    import {Steps} from '../Utils'
    import {Storage, Project, ConflictSyn} from '../../../core/Utils'
    import ProjectStepContainer from "../../../core/Components/ProjectStepContainer"
    import LinkStyleGuide from "../../../core/Components/LinkStyleGuide"

    export default {
        name: "DeepCustomerEmpathy4",
        components: {ProjectStepContainer, LinkStyleGuide},
        data() {
            return {
                step: Steps.FORM_EMPATHY_MAP,
                urlNextProject:'deep_customer_empathy_5',
                form: {
                    firstThing: "",
                    secondThing: "",
                    thirdThing: ""
                }
            }
        },
        mounted() {
            const forms = Storage.getProjectForms(this.$route.params.index)
            if (this.step in forms) this.form = forms[this.step]
        },
        methods: {
            updateProject() {
                const stepNumber = Steps.getStepFromForm(this.step)
                const index = this.$route.params.index
                Project.saveProjectStep(index, this.step, stepNumber, this.form, this.isOffline).then(response => {
                    if (response.project?.hasDifferenceVersion) {
                        ConflictSyn.show(response.index, response.project)
                    } else {
                        this.redirection()
                    }
                }).catch(err => {
                    this.redirection()
                })
            },
            redirection(){
                const index = this.$route.params.index
                this.$router.push({name: this.urlNextProject, params: {index}})
            }
        }
    }
</script>

